import LocalForage from "localforage";

export default class Cache {
  private readonly key: string;

  private readonly size: number;

  constructor(key: string, size: number = 10) {
    this.key = key;
    this.size = size;
  }

  async all() {
    return ((await LocalForage.getItem<any[]>(this.key)) || [])
      .filter(entry => !entry.expires || entry.expires > new Date())
      .filter(
        entry =>
          process.env.NODE_ENV !== "production" ||
          (entry.version && entry.version === process.env.VUE_APP_COMMIT_ID)
      );
  }

  async push(value: any) {
    await LocalForage.setItem(
      this.key,
      [
        { ...value, version: process.env.VUE_APP_COMMIT_ID },
        ...(await this.all())
      ].slice(0, this.size)
    );
  }

  async clear() {
    await LocalForage.removeItem(this.key);
  }
}
